<template>
  <v-container class="mx-5 mt-n2 table-container">
      <v-card class="elevation-0 mt-n2 size-card-statistics">
    
    <ProjectsStatistics v-if="selectedStatistic === $t('projects')"/>
    <SistemStatistics v-if="selectedStatistic === $t('system')" />
    <CamerasStatistics v-if="selectedStatistic === $t('cameras')"/>
  
    </v-card>

    
    
  </v-container>
</template>

<script>
import ProjectsStatistics from '@/views/statisticsView/components/ProjectsStatistics'
import SistemStatistics from '@/views/statisticsView/components/SistemStatistics'
import CamerasStatistics from '@/views/statisticsView/components/CamerasStatistics'
export default {
  components:{
      ProjectsStatistics,
      SistemStatistics,
      CamerasStatistics
  },
  data () {
    return {
    }
  },
  mounted(){
   
  },
  created(){
      if(this.startDate !== ''){
            this.startDate = this.$store.getters.getStartDate
            this.range = this.$store.getters.getRange
      } else{
            let date = new Date()
            this.startDate = date.toISOString().split("T")[0]
      }
      
  },
  computed:{
    selectedStatistic: {
      get() {
        return this.$store.getters.getSelectedStatistic;
      },
      set(value) {
        return this.$store.commit("setSelectedStatistic", value);
      },
    },
    startDate: {
        get(){
            return this.$store.getters.getStartDate
        },
        set(value){
            return this.$store.commit('setStartDate', value)
        }
    },
    range: {
        get(){
            return this.$store.getters.getRange
        },
        set(value){
            return this.$store.commit('setRange', value)
      }
    }
  },
  beforeDestroy(){

  },
  methods: {
    
  }
  
}
</script>
<style>

    
    .table-container{
        max-width: 98%!important;
    }
    
    .size-card-statistics{
        padding: 0px!important;
    }
    .title-statistics{
        font-size:16px!important;
        font-family: 'Roboto', 'sans-serif';
        color: #0d5ae5!important;
        display: inline-block;
    }
    .statistics-filter{
        max-width: 20%!important;
        font-size: 14px!important;
        display: inline-block;
        color: #0d5ae5!important;
        font-weight: normal;
    }
    .statistics-filter .v-select__selection--comma{
        margin: 0!important;
    }
    .time-filter{
        max-width: 100%!important;
    }
    .mj-daterange-picker .panels-choices{
        grid-template-columns: 1fr 1fr 1fr!important;
        padding: 10px!important;
    }
    .mj-daterange-picker .preset-ranges .preset{
        width: 25%!important;
        margin: 0!important;
        text-align: center!important;
        vertical-align: center!important;
    }
    .mj-daterange-picker .preset-ranges{
        padding: 10px!important;
    }
    .mj-calendar{
        padding: 10px!important;
    }
    .mj-calendar .calendar-days .day{
        height: 30px!important;
    }
    .mj-calendar .calendar-months .month{
        height: 30px!important;
    }
    .mj-daterange-picker .preset-ranges .preset{
        font-size: 10px!important;
    }
    .calendar{
        position: absolute!important;
        z-index: 20!important;
        right: 50px!important;
        top: 130px;
    }
    .time-filter{
        max-width: 100%!important;
    }
    .mj-daterange-picker .panels-choices{
        grid-template-columns: 1fr 1fr 1fr!important;
        padding: 10px!important;
    }
    .mj-daterange-picker .preset-ranges .preset{
        width: 25%!important;
        margin: 0!important;
        text-align: center!important;
        vertical-align: center!important;
    }
    .mj-daterange-picker .preset-ranges{
        padding: 10px!important;
    }
    .mj-calendar{
        padding: 10px!important;
    }
    .mj-calendar .calendar-days .day{
        height: 30px!important;
    }
    .mj-calendar .calendar-months .month{
        height: 30px!important;
    }
    .mj-daterange-picker .preset-ranges .preset{
        font-size: 10px!important;
    }
    .calendar{
        position: absolute!important;
        z-index: 20!important;
        right: 50px!important;
        top: 130px;
    }
    .range{
        position: absolute!important;
        z-index: 20!important;
        right: 50px!important;
        top: 62px!important;
        width: 290px!important;
        background-color: #fff;
        border: 2px solid rgb(233, 233, 233);
    }
    .option .mdi-radiobox-blank{
        font-size: 15px!important;
    }
    .option .v-label{
        font-size: 12px!important;
    }
    .radio-group .v-input--radio-group__input{
        justify-content: center!important;
    }
    .v-application .accent{
        background-color: #0d5ae5!important;
        border-color: #0d5ae5!important;
    }
    .v-application .accent--text{
        color: #0d5ae5!important;
        caret-color: #0d5ae5!important;
    }
    .btn-calendar{
      background-color: #fff!important;
    }
    .calendar-title{
      padding: 0!important;
    }
</style>
